import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';

import DocumentsTable from '../components/documentsTable/documentsTable';
import Main from '../../layout/main/main';

import './documents.scss';

const Documents: React.FC = () => {
  const { t } = useTranslate();

  return (
    <Main title={t('DOCUMENTS.PAGE_TITLE')} className='documents-page'>
      <DocumentsTable />
    </Main>
  );
};

export default Documents;
